// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/gmf-commercial/gmf-commercial.component.css
// module id = 570
// module chunks = 0